import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Dices } from "lucide-react";
import { NAV_LINKS, SITE } from "../mock";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0b0f1a]/85 border-b border-amber-400/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="relative">
              <div className="absolute inset-0 bg-amber-400/30 blur-xl rounded-full group-hover:bg-amber-400/50 transition-colors" />
              <div className="relative w-10 h-10 rounded-xl bg-gradient-to-br from-amber-300 to-amber-500 flex items-center justify-center shadow-lg shadow-amber-500/30">
                <Dices className="w-5 h-5 text-[#0b0f1a]" strokeWidth={2.5} />
              </div>
            </div>
            <div className="leading-tight">
              <div className="text-xl font-bold tracking-tight text-amber-300">{SITE.name}</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-400">Result &middot; Chart &middot; Updates</div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "text-amber-300 bg-amber-400/10"
                      : "text-slate-300 hover:text-amber-200 hover:bg-white/5"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <button
            type="button"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 rounded-md text-slate-300 hover:text-amber-300 hover:bg-white/5"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-3">
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-md text-sm font-medium ${
                      isActive
                        ? "text-amber-300 bg-amber-400/10"
                        : "text-slate-300 hover:text-amber-200 hover:bg-white/5"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
